import { Link } from "react-router-dom";
import { Logo } from "../../components/Logo";

export default function AuthShell({ title, subtitle, children, footer, admin }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#101820]">
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden">
        <div className="absolute inset-0 kera-pattern opacity-30" />
        <Link to="/" className="relative">
          <Logo className="h-10 w-auto" />
        </Link>
        <div className="relative">
          <h2 className="font-heading text-4xl font-extrabold text-[#FAF6EE] leading-tight">
            {admin ? "KERA Recruitment Command Centre" : "Build the next chapter of KERA"}
          </h2>
          <p className="mt-4 text-[#FAF6EE]/70 max-w-md">
            {admin
              ? "Screen, score and shortlist commercial talent with a transparent, auditable match engine."
              : "Authentic South Indian flavours, growing across Ireland and Europe. Your commercial career starts here."}
          </p>
        </div>
        <div className="relative text-[#FAF6EE]/40 text-xs">© {new Date().getFullYear()} KERA Ireland</div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 bg-[#FAF6EE]">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden mb-8 inline-block">
            <Logo className="h-9 w-auto" />
          </Link>
          <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-[#101820]">{title}</h1>
          {subtitle && <p className="mt-2 text-muted-foreground text-sm">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-center text-muted-foreground">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
